// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const timberYard = defineModel({
  id: "timber-yard",
  batchId: "future",
  name: "Timber yard",
  tags: ["building","timber","yard","low-poly","age-of-mcp","future"],
  summary: "Seasons and stores timber, supplying planks and beams to every site.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 1,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.6, 0.5, 0.1), color: "#a8804a", position: [0, 0.39, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#7a5a30", position: [-0.8, 0.39, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.5, 0.1), color: "#7a5a30", position: [0.8, 0.39, -0.55] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.5, 6), color: "#7a5a30", position: [-0.7, 0.39, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.5, 6), color: "#7a5a30", position: [0.7, 0.39, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.8, 0.475, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.8, 0.475, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [-0.8, 0.475, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.95, 4), color: "#6b4a26", position: [0.8, 0.475, 0.8] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.6, 0.95, 0.1), color: "#a8804a", position: [0, 0.615, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#7a5a30", position: [-0.8, 0.615, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#7a5a30", position: [0.8, 0.615, -0.55] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.95, 6), color: "#7a5a30", position: [-0.7, 0.615, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.95, 6), color: "#7a5a30", position: [0.7, 0.615, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.45, 4), color: "#6b4a26", position: [-0.8, 0.725, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.45, 4), color: "#6b4a26", position: [0.8, 0.725, -0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.45, 4), color: "#6b4a26", position: [-0.8, 0.725, 0.8] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 1.45, 4), color: "#6b4a26", position: [0.8, 0.725, 0.8] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(1.85, 0.14, 1.85), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.BoxGeometry(1.6, 0.95, 0.1), color: "#a8804a", position: [0, 0.615, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#7a5a30", position: [-0.8, 0.615, -0.55] },
      { geometry: new THREE.BoxGeometry(0.1, 0.95, 0.1), color: "#7a5a30", position: [0.8, 0.615, -0.55] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.95, 6), color: "#7a5a30", position: [-0.7, 0.615, 0.5] },
      { geometry: new THREE.CylinderGeometry(0.06, 0.06, 0.95, 6), color: "#7a5a30", position: [0.7, 0.615, 0.5] },
      { geometry: new THREE.BoxGeometry(1.84, 0.07, 0.797835), color: "#7a4a36", position: [0, 1.29, 0.31], rotation: [0.572966, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.84, 0.07, 0.797835), color: "#7a4a36", position: [0, 1.29, -0.31], rotation: [-0.572966, 0, 0] },
      { geometry: new THREE.BoxGeometry(1.86, 0.085, 0.085), color: "#5a3526", position: [0, 1.49, 0] },
      { geometry: new THREE.BoxGeometry(1, 0.07, 0.24), color: "#8a5f33", position: [-0.23, 0.175, -0.18] },
      { geometry: new THREE.BoxGeometry(1, 0.07, 0.24), color: "#8a5f33", position: [-0.17, 0.245, -0.18] },
      { geometry: new THREE.BoxGeometry(1, 0.07, 0.24), color: "#8a5f33", position: [-0.23, 0.315, -0.18] },
      { geometry: new THREE.BoxGeometry(1, 0.07, 0.24), color: "#8a5f33", position: [-0.17, 0.385, -0.18] },
      { geometry: new THREE.BoxGeometry(1, 0.07, 0.24), color: "#8a5f33", position: [-0.23, 0.455, -0.18] },
      { geometry: new THREE.BoxGeometry(1, 0.07, 0.24), color: "#8a5f33", position: [-0.17, 0.525, -0.18] },
      { geometry: new THREE.CylinderGeometry(0.13, 0.13, 1, 9), color: "#5f3f20", position: [0.5, 0.27, 0.18], rotation: [0, 0, 1.570796] },
      { geometry: new THREE.CylinderGeometry(0.12, 0.12, 1, 9), color: "#8a5f33", position: [0.5, 0.51, 0.18], rotation: [0, 0, 1.570796] },
    ] },
  ],
  animations: [],
});
